import React from "react";
import { navLinks } from "../data/content";
export function Footer() {
  return <footer className="border-t border-line bg-ink" data-id="element-102" data-mp="3gezdp53xpt1o">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10" data-id="element-103" data-mp="3ggu1cr6lbz9g">
        <p className="font-display text-6xl italic text-cream/90 sm:text-8xl lg:text-[9rem] lg:leading-none" data-id="element-104" data-mp="32oniuyfytg6u">Pardus Dei</p>
        <div className="mt-12 flex flex-col gap-8 border-t border-line pt-8 text-sm text-stone md:flex-row md:items-center md:justify-between" data-id="element-105" data-mp="36q94b86kf2sn">
          <p data-id="element-106" data-mp="38quwwb59nq4">© 2026 Chatterie Pardus Dei · Chats Bengal LOOF en Ardèche</p>
          <ul className="flex flex-wrap gap-x-8 gap-y-3" data-id="element-107" data-mp="37xv6falryhh">
            {navLinks.map(l => <li key={l.href} data-id="element-108" data-mp="3le2l2w7e0bct">
                <a href={l.href} className="transition-colors duration-150 hover:text-cream" data-id="element-109" data-mp="3qd6qrcv3rqye">
                  {l.label}
                </a>
              </li>)}
          </ul>
        </div>
      </div>
    </footer>;
}